import { useRef, useState } from "react"
import { FileText, UploadCloud } from "lucide-react"
import { Button } from "../../../ui"
import { PAYMENT_DOCUMENT_ACCEPT, PAYMENT_DOCUMENT_MAX_BYTES } from "../../../constants"
import { showToastError } from "utilities/toastUtil"

// Supporting files for the whole payment request — not the per-PO invoice PDF.
const AdditionalDocuments = ({ files, disabled, onAdd, onRemove }) => {
  const ref = useRef(null)
  const [over, setOver] = useState(false)

  const take = (list) => {
    const next = []
    Array.from(list || []).forEach((file) => {
      if (file.size > PAYMENT_DOCUMENT_MAX_BYTES) {
        showToastError(`${file.name} is larger than 10MB.`)
        return
      }
      next.push(file)
    })
    if (next.length) onAdd(next)
  }

  return (
    <div>
      <div
        className={`prc-drop${over ? " is-over" : ""}`}
        onDragOver={(e) => {
          e.preventDefault()
          setOver(true)
        }}
        onDragLeave={() => setOver(false)}
        onDrop={(e) => {
          e.preventDefault()
          setOver(false)
          if (!disabled) take(e.dataTransfer.files)
        }}
      >
        <div className="prc-drop-copy">
          <UploadCloud aria-hidden />
          <div>
            <strong>Drag and drop files here, or click to browse</strong>
            <span>Support: PDF, Excel, Word, images, XML — max 10MB each</span>
          </div>
        </div>
        <Button variant="secondary" size="sm" onClick={() => ref.current?.click()} disabled={disabled}>
          Upload files
        </Button>
        <input
          ref={ref}
          type="file"
          accept={PAYMENT_DOCUMENT_ACCEPT}
          multiple
          hidden
          onChange={(e) => {
            take(e.target.files)
            e.target.value = ""
          }}
        />
      </div>
      {files.length > 0 && (
        <div className="prc-files">
          {files.map((file, index) => (
            <span className="prc-file-chip" key={`${file.name}-${file.size}-${index}`} title={file.name}>
              <FileText aria-hidden />
              <span>{file.name}</span>
              <button type="button" aria-label={`Remove ${file.name}`} onClick={() => onRemove(index)} disabled={disabled}>
                ×
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  )
}

export default AdditionalDocuments
